import { useCallback, useState } from 'react'
import { apiDelete, apiGet, apiPost } from 'tennders-stracture/libs/api'
import { toast } from 'react-toastify'
import { useToast } from 'tennders-common/hooks/useToast'

const useMultipleCostInvoiceDrafts = ({
  onClose = null,
  setFormErrors = null
} = {}) => {
  const [drafts, setDrafts] = useState([])
  const [loading, setLoading] = useState(false)
  const { toastSuccess } = useToast()
  const initialLines = [{ id: 0 }]

  const scrollToTop = () => {
    const elementModal = document.getElementsByClassName('modal')
    if (elementModal?.length) {
      elementModal[0].scrollIntoView({ behavior: 'smooth' })
    }
  }
  const fetchDrafts = useCallback(async () => {
    setLoading(true)
    const drafts = await apiGet('/costInvoice/drafts')
    setDrafts(drafts)
    setLoading(false)
  }, [])

  const deleteDraft = useCallback(async (id) => {
    setLoading(true)
    await apiDelete('/costInvoice/drafts/' + id)
    fetchDrafts()
    setLoading(false)
    toastSuccess('Cost invoice draft deleted')
    if (onClose) {
      onClose()
    }
  }, [])

  const saveDraft = async (draft) => {
    setLoading(true)
    try {
      const response = await apiPost('/costInvoice/drafts', draft)
    } catch (e) {
      setLoading(false)
      const errors = e?.response?.data?.errors
      const _errors = errors
      if (_errors?.company_id) {
        _errors['invoiceNo'] = _errors.company_id
        toast.error(_errors.company_id)
      }
      setFormErrors(errors)
      scrollToTop()
      return false
    }
    setLoading(false)
    toast.success('Draft saved successfully')
    onClose()
    return true
  }

  return {
    drafts,
    fetchDrafts,
    saveDraft,
    loading,
    deleteDraft
  }
}

export default useMultipleCostInvoiceDrafts
